<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      .text-lg.font-semibold.mb-4 Mark as inactive?
      div This action will revert the medicine status from “Active” into its default state. Click “Confirm” to proceed
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline.mr-2(text :disabled="loading" @click="closeDialog") {{ $t('cancel') }}
      v-btn.button-md(:loading="loading" color="neutral700" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    parentMedication: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({company: 'getCompany'}),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    async handleConfirm () {
      try {
        this.loading = true
        const endpoint = `/clinics/${this.company.slug}/active_medications/${this.parentMedication.id}`
        await this.$axios.delete(endpoint)
        this.$emit('updated')
        this.updateActivityLog(endpoint, null, null, 'DELETE')
        this.showMessage(['success', 'Medication removed from active list'])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.loading = false
        this.closeDialog()
      }
    },
    updateActivityLog (endpoint, payload, response, method) {
      let data = {
        company: this.company.id,
        object_id: this.parentMedication.id,
        object_ref: 'active_medications',
        activity: `Deactivate active medications (patient_id: ${this.parentMedication.patient}, medication_id: ${this.parentMedication.medication.id})`,
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  },
}
</script>